import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  CanActivate,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';

import { UserAuth } from '@nrwl/common-lib';
import { get, some } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class RolesAuthenticationGuard implements CanActivate {
  roleAuthenticationPages = [
    {
      pages: ['active_test', 'active_test_update', 'truespeed_test'],
      authRole: 'MANAGE_TESTS'
    },
    {
      pages: ['add_datasource', 'update_datasource'],
      authRole: 'READ_WRITE'
    },
    {
      pages: ['user-administration', 'profile/:userName'],
      authRole: 'MANAGE_PERMISSIONS'
    }
  ];
  constructor(
    public router: Router,
    public userAuth: UserAuth,
    public activatedRoute: ActivatedRoute
  ) {}
  // add pageid which we need authorization based on authRole.

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const path =
      route.outlet === 'wizard'
        ? get(route.params, 'wizardId', '')
        : route.outlet === 'testSetup'
        ? get(route.params, 'testId', '')
        : route.fragment === 'dashboard'
        ? get(route.routeConfig, 'path', '')
        : '';
    let isAuthorized = true;
    if (path) {
      isAuthorized = !some(this.roleAuthenticationPages, role => {
        return role.pages.indexOf(path) > -1 && !this.userAuth.isAuthedFor(role.authRole);
      });
    }
    if (isAuthorized) {
      return true;
    } else {
      // No Authorization availabe- Go to Landing page
      this.router.navigate(['landing-page']);
      return false;
    }
  }
}
